import { createSlice } from "@reduxjs/toolkit";
import { CampaignMilestonesSlice } from "types/campaign/milestones";
import { fetchCampaignGigsThunk, fetchCampaignMilestonesThunk } from "./thunk";

const initialState: CampaignMilestonesSlice = {
    loading: false,
    error: null,
    items: {},
    gigs: {},
    gigs_loading: false,
    gigs_error: null
}

const campaignMilestones = createSlice({
    name: 'campaignMilestones',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Add cases for fetching milestones, etc. when implemented
        builder
            .addCase(fetchCampaignMilestonesThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCampaignMilestonesThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                const { campaignId, milestonesData } = action.payload;
                state.items[campaignId] = {
                    milestonesData,
                    last_fetched_at: Date.now()
                };
            })
            .addCase(fetchCampaignMilestonesThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch campaign milestones";
            })

            .addCase(fetchCampaignGigsThunk.pending, (state) => {
                state.gigs_loading = true;
                state.gigs_error = null;
            })
            .addCase(fetchCampaignGigsThunk.fulfilled, (state, action) => {
                state.gigs_loading = false;
                state.gigs_error = null;
                const { campaignId, gigs } = action.payload;
                state.gigs[campaignId] = {
                    items: gigs,
                    last_fetched_at: Date.now()
                };
            })
            .addCase(fetchCampaignGigsThunk.rejected, (state, action) => {
                state.gigs_loading = false;
                state.gigs_error = action.payload || "Failed to fetch campaign gigs";
            });

    }
})

export default campaignMilestones.reducer;